import { Typography, Container } from "@mui/material";
import SessionForm from "../../components/sessions/SessionForm";

export const SessionCreatePage: React.FC = () => {

  return (
    <Container disableGutters>
      <Typography variant="h4" align="center">
        Create a New Session
      </Typography>
      <SessionForm
        submitButtonText="Create Session"
        //maxPresenters={3} //uncomment this attribute to limit the number of presenters, default (without this attribute) is 2 presenters
      />
    </Container>
  );
};

export default SessionCreatePage;
